module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/EARTH_ELEMENTAL_STYLE.f83c57b8.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/EARTH_ELEMENTAL_STYLE.png
// module id = 1280
// module chunks = 16